import LinkStyled from './LinkStyled'

const Link = ({
  children = undefined,
  to = '/'
}) => {

  return (
    <LinkStyled
      href={to}
    >
      {children}
    </LinkStyled>
  )
}

export default Link
